import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader } from "@mantine/core";

function Private({ children }) {

    const [loading, setLoading] = useState(true);
    const [logado, setLogado] = useState(false);

    async function ckeckLogin() {
        const token = window.localStorage.getItem("x-access-token");
        axios({
            method: "post",
            url: "https://api-scaf.onrender.com/api/Session/VerifyToken",
            headers: {
                authorization: "Bearer "+token,
            },
        })
            .then((res) => {
                setLoading(false);
                setLogado(true);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
                setLogado(false);
            });
    }

    useEffect(() => {
        ckeckLogin();
    }, []);

    if (loading) {
        return (
            <div>
                <div className="d-flex justify-content-center pt-5 mt-5">
                    <div className="row">
                        <div className="col">
                            <Loader
                                size="xl"
                                variant="bars"
                                color="green"
                                style={{ width: "8rem" }}
                            />
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-center typewriter">
                    <div className="row">
                        <div className="col">
                            <div className="typewriter">
                                <h4>
                                    Aguarde, sua solicitação está sendo
                                    processada ...
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (!logado) {
        return <Navigate to="/login" />;
    }

    return children;
}

export default Private;
